var BOLD = window.BOLD || {};
BOLD.helpers = BOLD.helpers || {};
BOLD.helpers.getProductSync = function(handle, success_callback, options){
options = options || {};
var url = '/products/' + handle;
if(options.raw){
 url += '.js';
}
else{
 url += '?view=' + (options.view || 'json');
}

var xmlhttp;
// compatible with IE7+, Firefox, Chrome, Opera, Safari - Credit to Abdel Hady
xmlhttp = new XMLHttpRequest();
xmlhttp.onreadystatechange = function(){
 if (xmlhttp.readyState == 4 && xmlhttp.status == 200){
   try{
     var response = xmlhttp.responseText;
     if(typeof response === 'string'){
       response = JSON.parse(response);
     }
     if(typeof success_callback === 'function'){
       success_callback(response);
     }
     else if(typeof Shopify === 'object' && typeof Shopify.onProduct === 'function'){
       Shopify.onProduct(response);
     }
   }
   catch(err){
     if(options.raw){
       return false;
     }
     BOLD.helpers.getProduct(handle, success_callback, {raw: true});
   }
 }
}
xmlhttp.open("GET", url, false);
xmlhttp.send();

};

BOLD.helpers.getProduct = function(handle, success_callback, options){
options = options || {};
var url = '/products/' + handle;
if(options.raw){
 url += '.js';
}
else{
 url += '?view=' + (options.view || 'json');
}

var xmlhttp;
// compatible with IE7+, Firefox, Chrome, Opera, Safari - Credit to Abdel Hady
xmlhttp = new XMLHttpRequest();
xmlhttp.onreadystatechange = function(){
 if (xmlhttp.readyState == 4 && xmlhttp.status == 200){
   try{
     var response = xmlhttp.responseText;
     if(typeof response === 'string'){
       response = JSON.parse(response);
     }
     if(typeof success_callback === 'function'){
       success_callback(response);
     }
     else if(typeof Shopify === 'object' && typeof Shopify.onProduct === 'function'){
       Shopify.onProduct(response);
     }
   }
   catch(err){
     if(options.raw){
       return false;
     }
     BOLD.helpers.getProduct(handle, success_callback, {raw: true});
   }
 }
}
xmlhttp.open("GET", url, true);
xmlhttp.send();

};
